import { Box, Card, Paper, styled } from '@mui/material';
import { tokens } from '@/theme/foundations/tokens';

// Shared board surfaces: recessed lanes with gently raised project cards.
export const BoardProjectSurface = styled(Card)(({ theme }) => {
  const t = theme.palette.studio ?? tokens(theme.palette.mode);
  return {
    position: 'relative',
    borderRadius: 8,
    background: t.surfaces.cardGradientSoft,
    border: `1px solid ${t.borders.card}`,
    boxShadow: t.shadows.cardFlat,
    transition: theme.transitions.create([
      'border-color',
      'box-shadow',
      'transform',
    ]),
    '&:hover, &:focus-within': {
      borderColor: t.borders.control,
      boxShadow: t.shadows.card,
      transform: 'translateY(-1px)',
    },
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
  };
});

export const BoardLaneSurface = styled(Paper)(({ theme }) => {
  const t = theme.palette.studio ?? tokens(theme.palette.mode);
  return {
    background: t.surfaces.trackSoft,
    border: `1px solid ${t.borders.subtle}`,
    borderRadius: 10,
    overflow: 'hidden',
    boxShadow: t.shadows.controlInset,
  };
});

export const BoardMark = styled(Box)(({ theme }) => {
  const t = theme.palette.studio ?? tokens(theme.palette.mode);
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: 6,
    color: theme.palette.primary.main,
    background: t.surfaces.trackSoft,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: t.shadows.controlInset,
    flexShrink: 0,
  };
});
